import styles from "./ReleaseNote.module.css";
// import { Link } from "react-router-dom";
import ReleaseUpdate from "./component/BlogList";
import ReleaseUpdateImg from "./../../assets/images/blogthumbnail.jpg";
import { useEffect, useState } from "react";
import PageLoader from "../../components/PageLoader";
import Pagination from "@mui/material/Pagination";
import NotFounditem from "../error/NotFound";
import NoData from "../../assets/images/emptyperiod.png";
import { toast } from "react-toastify";
const ReleaseNote = () => {
  const [updates, setUpdates] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const updatesPerPage = 5;
  const lastIndex = currentPage * updatesPerPage;
  const firstIndex = lastIndex - updatesPerPage;
  const currentUpdates = updates.slice(firstIndex, lastIndex);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const fetchUpdates = async () => {
    try {
      const response = await fetch(
        "https://shelf21blog.com.ng/blog/?rest_route=/wp/v2/posts&_embed&per_page=100"
      );
      if (!response.ok) {
        throw new Error("Failed to fetch updates");
      }
      const total = parseInt(response.headers.get("X-WP-Total") || "0");
      const data = await response.json();
      // If there are more posts than the per_page limit, fetch remaining pages
      if (total > data.length) {
        const totalPages = Math.ceil(total / 100);
        const baseUrl = "https://shelf21blog.com.ng/blog/?rest_route=/wp/v2/posts&_embed&per_page=100";
        const extraFetches = Array.from({ length: totalPages - 1 }, (_, i) => fetch(`${baseUrl}&page=${i + 2}`).then((r) => r.json()));
        const extraData = await Promise.all(extraFetches);
        setUpdates([...data, ...extraData.flat()]);
      } else {
        setUpdates(data);
      }
    } catch (err) {
      toast.error(err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchUpdates();
  }, []);
  const decodeHTMLEntities = (text) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    return doc.documentElement.textContent || "";
  };

  const createSlug = (title) => {
    return title
      .toLowerCase()
      .replace(/[^\w\s-]/g, "")
      .replace(/\s+/g, "-")
      .replace(/--+/g, "-")
      .trim();
  };

  return (
    <div>
      <div className={`${styles.containerbcg}`}>
        <div className={`${styles.container}`}>
          <div className={`${styles.contmargin}`}>
            <div className={`${styles.releaseheader}`}>
              <h1>Insights & Updates from Shelf21</h1>
              <p>
                From time-saving features to proven school management strategies, get the insights that move your school forward.
              </p>
              <div className={`${styles.releaseupdate}`}>
                <p>
                  {loading
                    ? "Loading latest update..."
                    : updates[0]?.date
                      ? `Latest release was updated on ${new Date(
                        updates[0]?.date
                      ).toLocaleDateString()}.`
                      : "No updates available."}
                </p>
                <span>
                  {/* <Link to="/blog">Click to see release.</Link> */}
                </span>
              </div>
            </div>

            {loading && <PageLoader />}

            {!loading &&
              currentUpdates.map((update) => {
                const blogSlug = createSlug(update.title.rendered);

                return (
                  <ReleaseUpdate
                    key={update.id}
                    id={update.id}
                    slug={blogSlug}
                    updateimg={
                      update._embedded?.["wp:featuredmedia"]?.[0]?.source_url || ReleaseUpdateImg
                    }
                    updatetitle={update.title.rendered}
                    updatedesc={decodeHTMLEntities(
                      update.excerpt.rendered.replace(/(<([^>]+)>)/gi, "")
                    )}
                  />
                );
              })}

            {!loading && updates.length === 0 && (
              <NotFounditem
                img={NoData}
                title="No Blog found"
              />
            )}

            {!loading && updates.length > 0 && (
              <div className={`${styles.pagination}`}>
                <Pagination
                  count={Math.ceil(updates.length / updatesPerPage)}
                  page={currentPage}
                  onChange={handlePageChange}
                  className="custom-pagination"
                  shape="rounded"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReleaseNote;
